import { render, staticRenderFns } from "./Itempage.vue?vue&type=template&id=59594766"
import script from "./Itempage.vue?vue&type=script&lang=js"
export * from "./Itempage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports